module.exports = __webpack_public_path__ + "img/builder-7.fa8ed376.jpg";